'use client';

import React__default from 'react';

var TopManageIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 14 : _b, _c = _a.color, color = _c === void 0 ? '#FFAF00' : _c;
    return (React__default.createElement("svg", { width: width, height: width, viewBox: '0 0 14 14', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        React__default.createElement("path", { d: 'M7.35702 1.13576L8.69868 5.10803L12.8907 5.15656C13.2515 5.16076 13.4008 5.62043 13.1115 5.83556L9.74822 8.33876L10.9975 12.3409C11.1048 12.6853 10.7142 12.969 10.4197 12.7604L7.00002 10.3352L3.57982 12.76C3.28582 12.9686 2.89475 12.6844 3.00208 12.3404L4.25135 8.33829L0.888083 5.83509C0.598749 5.61996 0.748083 5.16029 1.10882 5.15609L5.30088 5.10756L6.64255 1.13529C6.75828 0.793692 7.24175 0.793692 7.35702 1.13576Z', fill: color })));
};

export { TopManageIcon as default };
//# sourceMappingURL=TopManageIcon.js.map
